import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Grid, Tab } from 'semantic-ui-react';

import { CustomSegment } from '../../../components';
import { ADMIN_USER, APP_NAME } from '../../../utils/constant';
import { find } from '../../../utils/lodash';
import { Broadcast, Communication, Organizations, ParentUsers } from './forms';

import '../admin.scss';

const Organisations = ({ match }) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();
  const auth = useSelector((state) => state.authentication);

  useEffect(() => {
    try {
      if (match.params.type) {
        changeRoute(match.params.type);
      }
    } catch (error) {
      console.error(error);
    }
  }, [match.params.type]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = `${t('admin.user_organisation.page_title')} | ${APP_NAME}`;
  }, []);

  const generateTabs = () => {
    const panes = [
      {
        menuItem: t('common.accounts'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            <CustomSegment
              title={t('admin.user_organisation.accounts.manage_account')}
              children={<Organizations />}
            />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.users'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            <ParentUsers />
          </Tab.Pane>
        ),
      },
      {
        menuItem: t('common.communication'),
        render: () => (
          <Tab.Pane attached={false} className="custom-tab">
            {auth.user.role === 'admin' ? (
              <CustomSegment
                title={t('notifications.broadcast_notification_super_admin')}
                children={<Broadcast />}
              />
            ) : (
              <>
                <CustomSegment
                  extraMargin
                  title={t('notifications.broadcast_notification')}
                  className="broadcast-notification"
                  children={<Communication isBroadcast={true} />}
                />
                <CustomSegment
                  extraMargin
                  title={t('notifications.received_notification')}
                  children={<Communication />}
                />
              </>
            )}
          </Tab.Pane>
        ),
      },
    ];

    return panes;
  };

  const onTabClick = (data) => {
    changeRoute(data.activeIndex);
  };

  // const onClickUsersExport = async () => {
  //   await dispatch(exportSystemUsers());
  //       const { usersCsvLink } = this.props;
  //   if (!isEmpty(usersCsvLink)) {
  //     window.open(usersCsvLink.download_link, '_blank');
  //   }
  // };

  const changeRoute = async (value) => {
    try {
      const tab = await find(ADMIN_USER(t), (o) => {
        return o.id === value || o.route === value;
      });
      setCurrentTab(tab.id);
      navigate(`/admin/accounts/${tab.route}`);
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return (
    <Grid.Row>
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={generateTabs()}
        className={isMobile ? 'custom-tabs-mobile' : 'custom-tabs'}
        activeIndex={currentTab}
        onTabChange={(e, data) => onTabClick(data)}
      />
    </Grid.Row>
  );
};

export default Organisations;
